import React from 'react';
import { Box, IconButton } from '@mui/material';
import clsx from 'clsx';        
import styles from './Controller.module.css';

function Controller({
  totalSlides = 3,
  currentSlide = 0,
  onPrevious = () => {},
  onNext = () => {},
  className,
}) {
  return (
    <Box className={clsx(styles.controller, className)}>
      {/* ← previous */}
      <Box className={styles.navButton}>
        <IconButton
          aria-label="Previous slide"
          onClick={onPrevious}
          className={styles.iconButton}
        >
          {/* same SVG as original */}
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.0002 0.00039C24.6162 0.00039 31.6002 6.98439 31.6002 15.6004C31.6002 24.2164 24.6162 31.2004 16.0002 31.2004C7.38419 31.2004 0.400192 24.2164 0.400192 15.6004C0.400192 6.98439 7.38419 0.00039 16.0002 0.00039ZM9.15219 14.7524C8.92749 14.9774 8.80119 15.2824 8.80119 15.6004C8.80119 15.9184 8.92749 16.2234 9.15219 16.4484L13.9522 21.2484C14.0621 21.3663 14.1945 21.4609 14.3417 21.5264C14.4889 21.592 14.6478 21.6273 14.809 21.6301C14.9701 21.633 15.1301 21.6033 15.2795 21.543C15.429 21.4826 15.5647 21.3928 15.6787 21.2789C15.7926 21.1649 15.8824 21.0292 15.9428 20.8797C16.0031 20.7303 16.0328 20.5703 16.0299 20.4092C16.0271 20.248 15.9918 20.0891 15.9262 19.9419C15.8607 19.7947 15.7661 19.6623 15.6482 19.5524L12.8962 16.8004H22.0002C22.3185 16.8004 22.6237 16.674 22.8487 16.4489C23.0738 16.2239 23.2002 15.9187 23.2002 15.6004C23.2002 15.2821 23.0738 14.9769 22.8487 14.7519C22.6237 14.5268 22.3185 14.4004 22.0002 14.4004H12.8962L15.6482 11.6484C15.8602 11.4209 15.9756 11.12 15.9701 10.8092C15.9646 10.4983 15.8386 10.2017 15.6188 9.98183C15.3989 9.76193 15.1023 9.63599 14.7914 9.63047C14.4805 9.62495 14.1797 9.74039 13.9522 9.95239L9.15219 14.7524Z"
              fill="url(#gradient-left)"
            />
            <defs>
              <linearGradient
                id="gradient-left"
                x1="16"
                y1="0"
                x2="16"
                y2="31.2"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFEC9A" />
                <stop offset="1" stopColor="#00B2FF" />
              </linearGradient>
            </defs>
          </svg>
        </IconButton>
      </Box>

      {/* ●●● indicators */}
      <Box className={styles.dots}>
        {Array.from({ length: totalSlides }).map((_, idx) => (
          <Box
            key={idx}
            className={clsx(styles.dot, {
              [styles.activeDot]: idx === currentSlide,
            })}
          />
        ))}
      </Box>

      {/* → next */}
      <Box className={styles.navButton}>
        <IconButton
          aria-label="Next slide"
          onClick={onNext}
          className={styles.iconButton}
        >
          {/* same SVG as original (mirrored arrow) */}
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16 0.00039C7.384 0.00039 0.4 6.98439 0.4 15.6004C0.4 24.2164 7.384 31.2004 16 31.2004C24.616 31.2004 31.6 24.2164 31.6 15.6004C31.6 6.98439 24.616 0.00039 16 0.00039ZM22.848 14.7524C23.073 14.9774 23.199 15.2824 23.199 15.6004C23.199 15.9184 23.073 16.2234 22.848 16.4484L18.048 21.2484C17.938 21.3663 17.805 21.4609 17.658 21.5264C17.511 21.592 17.352 21.6273 17.191 21.6301C17.03 21.633 16.87 21.6033 16.72 21.543C16.571 21.4826 16.435 21.3928 16.321 21.2789C16.207 21.1649 16.118 21.0292 16.057 20.8797C15.997 20.7303 15.967 20.5703 15.97 20.4092C15.973 20.248 16.008 20.0891 16.074 19.9419C16.139 19.7947 16.234 19.6623 16.352 19.5524L19.104 16.8004H10C9.682 16.8004 9.376 16.674 9.151 16.4489C8.926 16.2239 8.8 15.9187 8.8 15.6004C8.8 15.2821 8.926 14.9769 9.151 14.7519C9.376 14.5268 9.682 14.4004 10 14.4004H19.104L16.352 11.6484C16.14 11.4209 16.024 11.12 16.03 10.8092C16.035 10.4983 16.161 10.2017 16.381 9.98183C16.601 9.76193 16.898 9.63599 17.209 9.63047C17.519 9.62495 17.82 9.74039 18.048 9.95239L22.848 14.7524Z"
              fill="url(#gradient-right)"
            />
            <defs>
              <linearGradient
                id="gradient-right"
                x1="16"
                y1="0"
                x2="16"
                y2="31.2"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFEC9A" />
                <stop offset="1" stopColor="#00B2FF" />
              </linearGradient>
            </defs>
          </svg>
        </IconButton>
      </Box>
    </Box>
  );
}

export default Controller;
